import i18n from '@/locales/i18n';

const USER_TYPE = {
  USER_TYPE_GS_ADMIN: 1,
  USER_TYPE_CLIENT_MANAGER: 2,
  USER_TYPE_COMPANY_MANAGER: 3,
  USER_TYPE_STORE_MANAGER: 4,
  USER_TYPE_GENERAL: 5,
  USER_TYPE_4G: 6,
};

const constant = {
  type: USER_TYPE,
  types: [
    {
      value: USER_TYPE.USER_TYPE_GS_ADMIN,
      text: i18n.t('user.user_types.' + USER_TYPE.USER_TYPE_GS_ADMIN),
    },
    {
      value: USER_TYPE.USER_TYPE_CLIENT_MANAGER,
      text: i18n.t('user.user_types.' + USER_TYPE.USER_TYPE_CLIENT_MANAGER),
    },
    {
      value: USER_TYPE.USER_TYPE_COMPANY_MANAGER,
      text: i18n.t('user.user_types.' + USER_TYPE.USER_TYPE_COMPANY_MANAGER),
    },
    {
      value: USER_TYPE.USER_TYPE_STORE_MANAGER,
      text: i18n.t('user.user_types.' + USER_TYPE.USER_TYPE_STORE_MANAGER),
    },
    {
      value: USER_TYPE.USER_TYPE_GENERAL,
      text: i18n.t('user.user_types.' + USER_TYPE.USER_TYPE_GENERAL),
    },
    {
      value: USER_TYPE.USER_TYPE_4G,
      text: i18n.t('user.user_types.' + USER_TYPE.USER_TYPE_4G),
    },
  ],
  default_user_sort_column: 'created_at',
  statuses: [
    {
      value: 1,
      text: i18n.t('user.user_status.active'),
    },
    {
      value: 0,
      text: i18n.t('user.user_status.inactive'),
    },
  ],
  is_send_invoice_mail: {
    ON: 1,
    OFF: 0,
  },
  is_send_invoice_mail_options: [
    {
      value: '1',
      text: i18n.t('user.checkbox.send_invoice_mail'),
    },
    {
      value: '0',
      text: i18n.t('user.checkbox.not_send_invoice_mail'),
    },
  ],
  is_send_report_mail: {
    ON: 1,
    OFF: 0,
  },
  is_send_report_mail_options: [
    {
      value: '1',
      text: i18n.t('user.checkbox.send_report_mail'),
    },
    {
      value: '0',
      text: i18n.t('user.checkbox.not_send_report_mail'),
    },
  ],
  mail_flag_visible_user_types: [
    USER_TYPE.USER_TYPE_CLIENT_MANAGER,
    USER_TYPE.USER_TYPE_COMPANY_MANAGER,
    USER_TYPE.USER_TYPE_STORE_MANAGER,
  ],
};

export default constant;
